import React 		from 'react';
import PropTypes 	from 'prop-types';
import {ClickShowTooltip, HoverShowTooltip, HoverHideTooltip}	from '../common/_Utilities.jsx';

//this.props.classes	: string of classes
/*
	this.props.details 	: {
			flag: (optional) string of flag
		, storeName: string of name
		, link: (optional) string of link
		, feedbackRank: (optional) integer of feedbackbrick
	}
*/
//this.props.isBold 	: (optional) boolean

export default class SellerStoreLockup extends React.Component 
{
	constructor(props) 
	{
		super(props);
	}

	render() 
	{
		const {classes = '', isBold = true, showFeedbackCount = false, isClickable = false} = this.props;
		const {storeName, flag = '', link = '', feedbackRank = '', feedbackScore, favorite = false, instantCheckout = false} 	= this.props.details;

		var		feedbackIconUrl	= null;
		var 	feedbackToolTipTxt = "";

		if ( feedbackScore != null )
		{
			feedbackIconUrl	= blapp.url2.getFeedbackIconUrl( feedbackScore );
			feedbackToolTipTxt = blapp.util.getToolTipTxtFromFeedbackLevel( blapp.util.getLevelFromFeedbackScore(feedbackScore) );
		}
		else if ( feedbackRank != '' )
		{
			feedbackIconUrl	= blapp.url2.getFeedbackIconUrlByLevel( parseInt( feedbackRank ) );
			feedbackToolTipTxt = blapp.util.getToolTipTxtFromFeedbackLevel( parseInt( feedbackRank ) );
		}

		return (
			<div className={"store-detail-lockup " + classes + (!isBold ? ' store-detail-lockup--normal' : '')}>
				{flag ? <img className="store-detail-lockup__flag" src={blapp.url2.getCountryFlagUrl( flag )}/> : null}
				{link ? 
					<a className="store-detail-lockup__name store-detail-lockup--clickable" href={link} title={storeName}>{storeName}</a>
				: 
					<div className={"store-detail-lockup__name" + (isClickable ? ' store-detail-lockup--clickable' : '')} title={storeName}>{storeName}</div>
				}
				{showFeedbackCount ? <span className="l-margin-right--xs">({feedbackScore})</span> : null}
				{feedbackIconUrl ? <img className="store-detail-lockup__feedback-brick" src={feedbackIconUrl} data-tooltip={feedbackToolTipTxt} data-tooltip-width={180}  onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)} /> : null}
				{instantCheckout ? <i className="fa fa-bolt icon-instant-checkout store-detail-lockup__instant-checkout js-center-tooltip" data-tooltip={"Offers instant checkout"} data-tooltip-width={150} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}/> : null}
				{favorite ? <i className="far fa-thumbs-up store-detail-lockup__favorite js-center-tooltip" data-tooltip={"Favorite store"} data-tooltip-width={120} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}/> : null}
			</div>
		);
	}

	static getDetailsPropFromBLMStoreBasic( dmStoreBasic, noFlag, noLink )
	{
		return	{
					storeName:		dmStoreBasic.strStoreName
				,	flag:			noFlag ? null : dmStoreBasic.codeCountry
				,	link:			noLink ? null : blapp.url2.getStoreFrontUrl( dmStoreBasic.skUsernameOwner )
				,	feedbackScore:	dmStoreBasic.nFeedbackScore
				};
	}
}

SellerStoreLockup.propTypes = {
		classes: PropTypes.string
	,	details: PropTypes.shape({
				flag: PropTypes.string
			, storeName: PropTypes.string.isRequired
			, link: PropTypes.string
			, feedbackRank: PropTypes.number
		}).isRequired
	,	isBold: PropTypes.bool
}